import React from "react";
import { Helmet } from "react-helmet-async";
import Events from "core-web/libs/Events";
import {
    BasketEvents,
    CheckoutEvents,
    ErrorEvents,
    PageEvents,
    ProductEvents,
    PromotionEvents,
    SearchEvents,
} from "core-web/libs/Events/constants";
import { inServer } from "core-web/constants";
import BasketProductAdded from "./BasketProductAdded";
import BasketProductRemoved from "./BasketProductRemoved";
import CheckoutPayment from "./CheckoutPayment";
import CheckoutShipping from "./CheckoutShipping";
import CheckoutView from "./CheckoutView";
import ErrorLog from "./ErrorLog";
import PageView from "./PageView";
import ProductClick from "./ProductClick";
import ProductImpressions from "./ProductImpressions";
import ProductView from "./ProductView";
import PromotionClick from "./PromotionClick";
import PromotionImpressions from "./PromotionImpressions";
import Refund from "./Refund";
import Reset from "./Reset";
import Search from "./Search";
import Transaction from "./Transaction";

let initiated = false;
const GTM = () => {
    const subscribeEvents = () => {
        // Page
        Events.subscribe(PageEvents.RESET, () => Reset());
        Events.subscribe(PageEvents.VIEW, PageView);

        // Error
        Events.subscribe(ErrorEvents.LOG, ErrorLog);

        // Basket
        Events.subscribe(BasketEvents.PRODUCT_ADDED, BasketProductAdded);
        Events.subscribe(BasketEvents.PRODUCT_REMOVED, BasketProductRemoved);

        // Promotion
        Events.subscribe(PromotionEvents.CLICK, PromotionClick);
        Events.subscribe(PromotionEvents.IMPRESSIONS, PromotionImpressions);

        // Search
        Events.subscribe(SearchEvents.SUBMITTED, Search);

        // Product
        Events.subscribe(ProductEvents.VIEW, ProductView);
        Events.subscribe(ProductEvents.CLICK, ProductClick);
        Events.subscribe(ProductEvents.IMPRESSIONS, ProductImpressions);

        // Checkout
        Events.subscribe(CheckoutEvents.VIEW, CheckoutView);
        Events.subscribe(CheckoutEvents.SHIPPING, CheckoutShipping);
        Events.subscribe(CheckoutEvents.PAYMENT, CheckoutPayment);
        Events.subscribe(CheckoutEvents.TRANSACTION, Transaction);
        Events.subscribe(CheckoutEvents.REFUND, Refund);
    };

    if (!inServer && !initiated) {
        subscribeEvents();
        initiated = true;
    }

    const gtmTrackingKey = process.env.REACT_APP_GTM_TRACKING_KEY;

    if (!gtmTrackingKey) {
        return null;
    }

    return (
        <>
            <Helmet>
                {/* <!-- Google Tag Manager --> */}
                <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmTrackingKey}');`}</script>
                {/* <!-- End Google Tag Manager --> */}
            </Helmet>
        </>
    );
};

export default GTM;
